import React from 'react';

import {Spinner} from '@ergeon/core-components';

const Loader = () => {
  return (
    <div
      className="flex items-center flex-col justify-center h-screen bg-white dark:bg-gray-900"
      data-testid="loader"
    >
      <Spinner active borderWidth={0.16} color="blue" size={64} />
    </div>
  );
};

export default Loader;
